import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *拍摄成果列表
 * @param params
 * 
*/

export const resultList = params => Http.get(`${baseUrl}/sz/team/ps`, { params })
